module.exports = __webpack_public_path__ + "img/appAsset-brand--piriod.b0eb68b8.svg";